import { useEffect, useState, useRef } from "react";
import L from "leaflet";
import CloseIcon from "@mui/icons-material/Close";

const Map = () => {
  const [mapPolyline, setMapPolyline] = useState();
  const [open, setOpen] = useState(false);
  const mapRef = useRef(null);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  // Set up the event listener only once
  useEffect(() => {
    const handlePolylineCreated = (e) => {
      setMapPolyline(e.detail);
    };

    document.addEventListener("polyLineCreated", handlePolylineCreated);

    return () => {
      document.removeEventListener("polyLineCreated", handlePolylineCreated);
    };
  }, []);

  useEffect(() => {
    if (mapPolyline) {
      document.getElementById("mapContainer").style.height = "300px";
      document.getElementById("mapContainer").style.overflow = "visible";
      document.getElementById("close").style.display = "flex";

      // Remove the old map instance if it exists
      if (mapRef.current) {
        mapRef.current.remove();
        mapRef.current = null;
      }

      var container = L.DomUtil.get("map");

      if (container != null) {
        container._leaflet_id = null;
      }
      
      let map = new L.Map("map", {
        center: [48.61, 6.125],
        zoom: 4,
        dragging: true,
        touchZoom: true,
        scrollWheelZoom: true,
        doubleClickZoom: true,
        boxZoom: true,
        keyboard: true,
        zoomControl: true,
      });
      
      // Store the map instance
      mapRef.current = map;

      const here = {
        apiKey: "S2KHH3xUr5s9Nt8x5ksORqcIQYXcfrwlxoQy-qL07OU",
      };
      const style = "explore.day";

      const hereTileUrl =
        `https://maps.hereapi.com/v3/base/mc/{z}/{x}/{y}/png8` +
        `?apiKey=${here.apiKey}` +
        `&style=${style}` +
        `&ppi=400` +
        `&size=512`;

      let layerOptions = {};

      new L.TileLayer(hereTileUrl, layerOptions).addTo(map);

      const routePolyline = [{ type: "LineString", coordinates: mapPolyline }];

      new L.GeoJSON(routePolyline, {
        pane: "overlayPane",
        style: { color: "#575757", weight: 7 },
      }).addTo(map);
      
      // Fit bounds to show the entire route
      const bounds = L.geoJSON(routePolyline).getBounds();
      if (bounds.isValid()) {
        map.fitBounds(bounds, { padding: [50, 50] });
      }
    }
  }, [mapPolyline]);

  return (
    <div id="mapContainer">
      <div
        className="closeIcon"
        id="close"
        onClick={() => {
          document.getElementById("mapContainer").style.height = "0px";
          document.getElementById("mapContainer").style.overflow = "hidden";
          document.getElementById("close").style.display = "none";
        }}
      >
        <CloseIcon />
      </div>
      <div id="map"></div>
    </div>
  );
};

export default Map;
